const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getAnchorInfo = async (anchorId) => {
  try {
    const token = localStorage.getItem("authToken");
    const response = await fetch(`${BASE_URL}/eci/apis/v4/wallets/${anchorId}/get_anchor_info`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch anchor info");
    }

    const data = await response.json();
    return data.msg;
  } catch (error) {
    console.error("Error fetching anchor info:", error);
    throw error;
  }
};
